import React, { memo } from 'react';
import useSearchParams from '@/components/search/hooks/useSearchParams';
import usePlaceName from '@/components/search/hooks/usePlaceName';
import { getFilteredH1 } from '../../utils/Utils';
import { useRouter } from 'next/router';
import { addCommas } from '@persian-tools/persian-tools';
import styles from './RegionTitle.module.scss';
import Box from '@/components/UI/box/Box';
import Skeleton from '@/components/UI/skeleton/Skeleton';
import Typography from '@/components/UI/typography/Typography';
import { SearchDataProps } from '@/components/search/_types/searchDataType';
const RegionTitle = ({
  data
}: {
  data: SearchDataProps;
}) => {
  const {
    params,
    queries
  } = useSearchParams();
  const {
    city,
    province,
    url,
    village
  } = params;
  const router = useRouter();
  const href = `https://www.shab.ir${url}`;
  const placeName = usePlaceName(queries);
  const text = getFilteredH1({
    queries,
    city,
    province,
    data,
    placeName,
    village
  });
  if (!text) return <></>;
  return <Box className={styles['region-title-container']} data-sentry-element="Box" data-sentry-component="RegionTitle" data-sentry-source-file="RegionTitle.tsx">
      {data?.loading ? <>
          <Skeleton width={150} />
          <Skeleton width={100} />
        </> : <>
          <Typography component="h1" variant="bodyL" color="neutral_900">
            {text}
          </Typography>
          <Typography variant="bodyS" className={styles['house-count-text']}>
            {data?.pagination?.total ? router.asPath === '/search' ? '(10,000+ اقامتگاه پیدا شد)' : ` (${addCommas(data?.pagination?.total)} اقامتگاه)` : ''}
          </Typography>
        </>}
    </Box>;
};
export default memo(RegionTitle);